import { connect } from 'react-redux';
import { addNewAnnotation, positionAnnotation, } from '../actionCreators/annotation';
import HotspotLayer from '../components/HotspotLayer';
import { isInAnnotationMode } from '../selectors/annotation';
import { isInHandoffMode } from '../selectors/handoff';
import { getColumnsEnabled, getRowsEnabled } from '../selectors/layoutOverlay';
import { isTransitionComplete } from '../selectors/screen';
function mapStateToProps(state) {
    var areLayoutRowsEnabled;
    var areLayoutColumnsEnabled;
    if (isInHandoffMode(state)) {
        // TODO can remove this try/catch when using the v2 canvas api
        try {
            areLayoutRowsEnabled = getRowsEnabled(state);
            areLayoutColumnsEnabled = getColumnsEnabled(state);
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
    }
    return {
        isInAnnotationMode: isInAnnotationMode(state),
        isInHandoffMode: isInHandoffMode(state),
        isScreenTransitionComplete: isTransitionComplete(state),
        areLayoutRowsEnabled: areLayoutRowsEnabled,
        areLayoutColumnsEnabled: areLayoutColumnsEnabled,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onClick: function (screenArea, clickPosition) {
            dispatch(addNewAnnotation(screenArea, clickPosition));
        },
        positionAnnotation: function (commentUUID, screenArea, position) {
            dispatch(positionAnnotation(commentUUID, screenArea, position));
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HotspotLayer);
